"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWinesGastronomyThematic = void 0;
var React = __importStar(require("react"));
var IconWinesGastronomyThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M7,13 C10.28,13 10.869,9.357 10.976,8 L3.024,8 C3.131,9.357 3.72,13 7,13 Z M3,7 L11,7 L11,6.001 L3,6.001 L3,7 Z M11.5,5.001 C11.776,5.001 12,5.225 12,5.501 L12,7.5 C12,9.648 11.038,13.619 7.5,13.966 L7.5,18.001 L9.5,18.001 C9.776,18.001 10,18.225 10,18.501 C10,18.777 9.776,19.001 9.5,19.001 L4.5,19.001 C4.224,19.001 4,18.777 4,18.501 C4,18.225 4.224,18.001 4.5,18.001 L6.5,18.001 L6.5,13.966 C2.962,13.619 2,9.648 2,7.5 L2,5.501 C2,5.225 2.224,5.001 2.5,5.001 L11.5,5.001 Z M15.0049,9.167 C15.0119,9.148 15.4949,9.322 16.0749,9.527 L16.4079,9.646 L16.4079,18.5 C16.4079,18.776 16.1849,19 15.9079,19 C15.6319,19 15.4079,18.776 15.4079,18.5 L15.4079,10.352 C14.2529,9.938 13.9999,9.783 13.9999,9 L13.9999,5.5 C13.9999,5.224 14.2239,5 14.4999,5 C14.7759,5 14.9999,5.224 14.9999,5.5 L14.9999,9 C14.9999,9.067 14.9959,9.121 15.0049,9.167 Z M16,5 C16.276,5 16.5,5.224 16.5,5.5 L16.5,8.5 C16.5,8.776 16.276,9 16,9 C15.724,9 15.5,8.776 15.5,8.5 L15.5,5.5 C15.5,5.224 15.724,5 16,5 Z M17.5,5 C17.776,5 18,5.224 18,5.5 L18,8.5 C18,8.776 17.776,9 17.5,9 C17.224,9 17,8.776 17,8.5 L17,5.5 C17,5.224 17.224,5 17.5,5 Z M21.5,5 L22,5 L22,18.5 C22,18.776 21.776,19 21.5,19 C21.224,19 21,18.776 21,18.5 L21,6.987 C20.797,7.349 20.601,7.76 20.477,8.15 C20.258,8.844 20.159,9.731 20.219,10.051 C20.386,10.132 20.5,10.303 20.5,10.5 C20.5,10.776 20.276,11 20,11 C19.77,11 19.565,10.895 19.425,10.702 C18.879,9.958 19.517,7.87 19.523,7.85 C19.708,7.265 20.757,5 21.5,5 Z" }))); };
exports.IconWinesGastronomyThematic = IconWinesGastronomyThematic;
exports.IconWinesGastronomyThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconWinesGastronomyThematic;
